import cn from 'classnames'
import { memo, useCallback, useMemo } from 'react'

import { PartnerHierarchyType } from 'clickNgo/entities/partner/configs'
import { IPartner, IPartnerFlags } from 'clickNgo/entities/partner/models'
import { Translation } from 'cng-common/features/translations'
import { Tooltip } from 'core-components/library/tooltip'
import { getFormatDate } from 'core/classes/helpers/DateHelper'

import { companyDetailsTranslations } from '../../translation'

import { AMPLYFY_PROGRAM, EXTENDED_ATTR_SECOND } from './configs'
import { checkBlackListFlag, getPartnerTypeDescription } from './helpers'

import styles from './CompanyDetailsHeader.module.scss'

type Props = {
  partner: IPartner
  partnerFlags: IPartnerFlags
}

export const CompanyDetailsHeader = memo<Props>(({ partner, partnerFlags }) => {
  const { hierarchyType, partnerType, partnerTypeStartDate } = partner
  const partnerTypeDescription = getPartnerTypeDescription(partnerType)
  const bpNotAddressable = useMemo(() => {
    const isAmplifyProgram = AMPLYFY_PROGRAM.includes(partnerType)
    const isBlackListFlag = checkBlackListFlag(partnerFlags)

    return !isAmplifyProgram && isBlackListFlag ? EXTENDED_ATTR_SECOND : ''
  }, [partnerFlags, partnerType])
  const isHQ = hierarchyType === PartnerHierarchyType.HEADQUARTERS

  const partnerTypeDescriptionTip = useCallback(
    () => <>{partnerTypeDescription}</>,
    [partnerTypeDescription]
  )

  const hpMemberUnderAmplifyStartDate = useMemo(
    () => (partnerTypeStartDate ? getFormatDate(new Date(partnerTypeStartDate), 'date2') : ''),
    [partnerTypeStartDate]
  )

  const hpMemberUnderAmplifyStartYear = useMemo(
    () =>
      partnerTypeStartDate ? getFormatDate(new Date(partnerTypeStartDate), 'custom', 'YYYY') : '',
    [partnerTypeStartDate]
  )

  const hpMemberUnderAmplifyTip = useCallback(
    () => (
      <span>
        <Translation text={companyDetailsTranslations.header.hpMemberUnderAmplifySince} />
        {hpMemberUnderAmplifyStartDate}
      </span>
    ),
    [hpMemberUnderAmplifyStartDate]
  )

  return (
    <div className={cn(styles.container, { [styles.bpNotAddressable]: bpNotAddressable })}>
      <div className={styles.hierarchyTypeIcon}>{isHQ ? 'HQ' : 'Branch'}</div>
      <div className={styles.partnerTypeContainer}>
        <Tooltip disabled={!partnerTypeDescription} tipContent={partnerTypeDescriptionTip}>
          <div className={styles.partnerType}>{partnerType}</div>
          <div className={styles.bpNotAddressable}>{bpNotAddressable}</div>
        </Tooltip>
      </div>
      <div className={styles.hpMemberUnderAmplify}>
        <Tooltip tipContent={hpMemberUnderAmplifyTip}>
          <div>{hpMemberUnderAmplifyStartYear}</div>
        </Tooltip>
      </div>
    </div>
  )
})
